import { Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import { ImageBasic } from "components/Image";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function NotFound() {
  const userData = useSelector((state) => state.userData);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData.active) {
      navigate("/home");
    } else {
      navigate("/");
    }
  }, [navigate, userData.active]);

  return (
    <Flex
      position={"absolute"}
      bg={"white"}
      h="100vh"
      w="100%"
      // flex={1}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      p={"2rem"}
    >
      <ImageBasic
        alignSelf={"center"}
        p={"30px"}
        src={"./img/img-brand-logo-dark.png"}
        h={"20rem"}
      />
      <Flex h={"2.5rem"} overflow={"hidden"}>
        <Spinner size="md" color="spinner" colorPalette={"spinner"} />
      </Flex>
      <Heading textAlign={"center"} size="xl" color="fontdark" mt="2.5" mb="8">
        {/* PAGE NOT FOUND */} {"  "}
      </Heading>
      <Text textAlign="center" color="primary" mt="5%">
        2024 - AU Warranties Ltd
      </Text>
    </Flex>
  );
}

export default NotFound;
